<template>
  <div class="animated fadeIn">
            <AppHeader  class="bg-header" fixed > 
          <b-link class="navbar-brand" to="#">
            <img class="navbar-brand-full" :src="`${$store.state.app_url}/img/logo_cie.png`" width="45" height="45" alt="Logo Orange">
            <!-- <img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo"> -->
          </b-link>
          <!-- <b-navbar-nav class="d-md-down-none">
            <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
            <b-nav-item class="px-3" to="/users"  exact>Users</b-nav-item>
            <b-nav-item class="px-3" >Settings</b-nav-item>
          </b-navbar-nav> -->
          <b-navbar-nav class="ml-auto">
             <b-nav-item color="#ffff" class="d-md-down-none menu-item" >
              <b-link class="text-white">
                <i class="icon-home"></i>
                  Accueil
                </b-link>
              </b-nav-item>

            <b-nav-item class="d-md-down-none menu-item" @click="$router.push('/pages/login')" >
              <b-link class="text-white">
                <i class="icon-login"></i>
                Se connecter
              </b-link>
            </b-nav-item>
          
            <b-nav-item class="d-md-down-none menu-item" @click="$router.push('/pages/register')" >
              <b-link class="text-white">
                <i class="icon-register"></i>
                S'inscrire
              </b-link>
            </b-nav-item>
            <!-- <b-nav-item class="d-md-down-none">
              <i class="icon-location-pin"></i>
            </b-nav-item> -->
          </b-navbar-nav>

          <!-- <AsideToggler class="d-none d-lg-block" /> -->
          <!--<AsideToggler class="d-lg-none" mobile />-->
        </AppHeader> 
  </div>
</template>

<script>
import { Header as AppHeader } from '@coreui/vue'

export default {
  name: 'contact',
  components: {
   AppHeader
  },
  data: function () {
    return {
 
    }
  },
  methods: {

  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
